import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { state, transition, style, animate, trigger } from "@angular/animations";
import { SitefinityPanelItem, ADPResourceService as ResourceService } from 'digital-core';
import { GoogleAnalyticsService } from "common";

@Component({
  selector: 'portal-panel-accordion',
  templateUrl: './portal-panel-accordion.component.html',
  styleUrls: ['./portal-panel-accordion.component.scss'],
  animations: [
    trigger("iconRotator", [
      state("collapsed", style({ transform: "rotate(0deg)" })),
      state("expanded", style({ transform: "rotate(180deg)", })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
      ),
    ])
  ],
})
export class PortalPanelAccordionComponent implements OnInit {
  @Input() panelItem: SitefinityPanelItem;
  @Input() expandPanelNumber: number;
  @Input() panelKey: string;
  @Input() isBanner: boolean = false;
  @Input() iconOrientation: string;
  @Input() isPanelFixedWidth: boolean = false;
  @Input() isBodyLeftAligned: boolean;
  @Output() opened: EventEmitter<SitefinityPanelItem> = new EventEmitter<SitefinityPanelItem>();
  isIconRightOriented: boolean = true;
  expanded = false;
  isPanelBodyEmpty: boolean = false;
  openIcon = null;
  closeIcon = null;
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ResourceService) {
  }

  ngOnInit(): void {
    let closeIc = this.resourceService.getPortalSetting("Global_Accordion_Close_Icon").Value;
    let openIc = this.resourceService.getPortalSetting("Global_Accordion_Open_Icon").Value;
    if (!!this.panelItem && this.panelItem.Body.trim() == '') {
      this.isPanelBodyEmpty = true;
    }
    if (this.panelItem && this.panelItem.IconName) {
      var iconList = this.panelItem.IconName.split(',');
      if (iconList.length > 0) {
        this.openIcon = iconList[0];
      }
      if (iconList.length > 1) {
        this.closeIcon = iconList[1];
      }
    }
    else {
      this.closeIcon = closeIc;
      this.openIcon = openIc;
    }
    this.isIconRightOriented = this.iconOrientation == 'RIGHT';
  }

  openedPanel() {
    this.googleAnalyticsService.faqAccordion(this.panelItem.Header);
    this.expanded = true;
    this.opened.emit();
  }
}
